<template>
  <div class="basic-info-settings">
    <el-form label-width="120px">
      <!-- 店铺图标 -->
      <el-form-item label="店铺图标">
        <el-upload
            class="avatar-uploader"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
            :on-success="handleIconSuccess"
            :before-upload="beforeIconUpload">
          <img v-if="basicInfo.icon" :src="basicInfo.icon" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>

      <!-- 轮播图设置 -->
      <el-form-item label="店铺轮播图">
        <div class="banner-list">
          <div v-for="(banner, index) in basicInfo.banners" :key="index" class="banner-item">
            <el-upload
                class="banner-uploader"
                action="https://jsonplaceholder.typicode.com/posts/"
                :show-file-list="false"
                :auto-upload="true"
                :on-success="(res, file) => handleBannerSuccess(res, file, index)"
                :before-upload="beforeBannerUpload">
              <img v-if="banner.image" :src="banner.image" class="banner">
              <i v-else class="el-icon-plus banner-uploader-icon"></i>
            </el-upload>
            <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                @click="removeBanner(index)"
                class="banner-delete-btn"
                size="small"></el-button>
          </div>

          <div v-if="basicInfo.banners.length < 5" class="banner-add-btn">
            <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                :show-file-list="false"
                :auto-upload="true"
                :on-success="handleAddBanner"
                :before-upload="beforeBannerUpload">
              <el-button type="primary" icon="el-icon-plus" size="small">添加轮播图</el-button>
            </el-upload>
          </div>
        </div>
        <div class="banner-tip">建议尺寸：750×350像素，最多可上传5张</div>
      </el-form-item>

      <!-- 营业时间设置 -->
      <!-- 营业时间设置 -->
      <el-form-item label="营业时间">
        <div class="work-time-global">
          <div class="time-set-default">
            <el-time-select
                v-model="basicInfo.defaultWorkTime.startTime"
                :picker-options="timePickerOptions"
                placeholder="开始时间">
            </el-time-select>
            <span class="time-separator">至</span>
            <el-time-select
                v-model="basicInfo.defaultWorkTime.endTime"
                :picker-options="timePickerOptions"
                placeholder="结束时间">
            </el-time-select>
            <el-checkbox
                v-model="basicInfo.defaultWorkTime.is24Hours"
                @change="handleDefault24HoursChange">
              24小时营业
            </el-checkbox>
            <el-button
                type="primary"
                @click="applyToAllDays"
                class="apply-all-btn"
                size="small">
              一键应用到所有工作日
            </el-button>
          </div>

          <el-collapse v-model="activeCollapse" class="custom-collapse">
            <el-collapse-item name="1">
              <template #title>
                <span class="custom-collapse-title">为每个工作日单独设置</span>
              </template>
              <div v-for="day in weekDays" :key="day.value" class="work-time-item">
                <div class="day-label">{{day.label}}：</div>
                <el-time-select
                    v-model="basicInfo.workTime[day.value].startTime"
                    :picker-options="timePickerOptions"
                    placeholder="开始时间">
                </el-time-select>
                <span class="time-separator">至</span>
                <el-time-select
                    v-model="basicInfo.workTime[day.value].endTime"
                    :picker-options="timePickerOptions"
                    placeholder="结束时间">
                </el-time-select>
                <el-checkbox
                    v-model="basicInfo.workTime[day.value].is24Hours"
                    @change="handleDay24HoursChange(day.value)">
                  24小时营业
                </el-checkbox>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-form-item>

      <!-- 其他信息 -->
      <el-form-item label="联系电话">
        <el-input v-model="basicInfo.phone" placeholder="请输入联系电话" class="custom-input" size="small"></el-input>
      </el-form-item>

      <el-form-item label="详细地址">
        <el-input
            v-model="basicInfo.address"
            type="textarea"
            placeholder="请输入详细地址"
            :rows="3"
            class="custom-textarea"
            size="small"></el-input>
      </el-form-item>

      <el-form-item label="店铺描述">
        <el-input
            v-model="basicInfo.description"
            type="textarea"
            placeholder="请输入店铺描述"
            :rows="4"
            class="custom-textarea"
            size="small"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="saveSettings" class="submit-btn">保存设置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'BasicInfoSettings',
  props: {
    shop: {
      type: Object,
      required: true
    }
  },
  data() {
    const defaultWorkTime = {
      startTime: '09:00',
      endTime: '18:00',
      is24Hours: false
    };

    const dayWorkTime = {
      monday: { ...defaultWorkTime },
      tuesday: { ...defaultWorkTime },
      wednesday: { ...defaultWorkTime },
      thursday: { ...defaultWorkTime },
      friday: { ...defaultWorkTime },
      saturday: { startTime: '10:00', endTime: '16:00', is24Hours: false },
      sunday: { startTime: '10:00', endTime: '16:00', is24Hours: false }
    };

    return {
      activeCollapse: [],
      weekDays: [
        { value: 'monday', label: '周一' },
        { value: 'tuesday', label: '周二' },
        { value: 'wednesday', label: '周三' },
        { value: 'thursday', label: '周四' },
        { value: 'friday', label: '周五' },
        { value: 'saturday', label: '周六' },
        { value: 'sunday', label: '周日' }
      ],
      basicInfo: JSON.parse(JSON.stringify(this.shop.basicInfo || {
        icon: '',
        banners: [],
        defaultWorkTime: { ...defaultWorkTime },
        workTime: JSON.parse(JSON.stringify(dayWorkTime)),
        phone: '',
        address: '',
        description: ''
      }))
    }
  },
  methods: {
    handleIconSuccess(res, file) {
      this.basicInfo.icon = URL.createObjectURL(file.raw);
    },
    beforeIconUpload(file) {
      const isImage = ['image/jpeg', 'image/png'].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isImage && isLt2M;
    },
    handleBannerSuccess(res, file, index) {
      this.$set(this.basicInfo.banners, index, {
        image: URL.createObjectURL(file.raw)
      });
    },
    handleAddBanner(res, file) {
      this.basicInfo.banners.push({
        image: URL.createObjectURL(file.raw)
      });
    },
    beforeBannerUpload(file) {
      return this.beforeIconUpload(file);
    },
    removeBanner(index) {
      this.basicInfo.banners.splice(index, 1);
    },
    handleDefault24HoursChange(val) {
      if (val) {
        this.basicInfo.defaultWorkTime.startTime = '00:00';
        this.basicInfo.defaultWorkTime.endTime = '23:59';
      }
    },
    handleDay24HoursChange(day, val) {
      if (val) {
        this.basicInfo.workTime[day].startTime = '00:00';
        this.basicInfo.workTime[day].endTime = '23:59';
      }
    },
    applyToAllDays() {
      if (this.basicInfo.defaultWorkTime.is24Hours) {
        for (const day in this.basicInfo.workTime) {
          this.basicInfo.workTime[day] = {
            startTime: '00:00',
            endTime: '23:59',
            is24Hours: true
          };
        }
      } else {
        for (const day in this.basicInfo.workTime) {
          this.basicInfo.workTime[day] = {
            startTime: this.basicInfo.defaultWorkTime.startTime,
            endTime: this.basicInfo.defaultWorkTime.endTime,
            is24Hours: false
          };
        }
      }
      this.$message.success('已应用到所有工作日');
    },
    saveSettings() {
      // 验证轮播图
      if (this.basicInfo.banners.length === 0) {
        this.$message.warning('请至少上传一张轮播图');
        return;
      }

      // 验证默认营业时间
      if (!this.basicInfo.defaultWorkTime.is24Hours &&
          (!this.basicInfo.defaultWorkTime.startTime || !this.basicInfo.defaultWorkTime.endTime)) {
        this.$message.error('请设置默认营业时间');
        return;
      }

      this.$emit('save', this.basicInfo);
    }
  }
}
</script>

<style scoped lang="scss">
.basic-info-settings {
  padding-top: 20px;

  .el-form-item {
    margin-bottom: 28px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

/* 上传区域样式 */
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
  transition: border-color 0.3s;

  &:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .avatar {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
}

/* 轮播图样式 */
.banner-list {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 10px;

  .banner-item {
    position: relative;
    width: 200px;

    .banner-uploader {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 200px;
      height: 100px;
      transition: border-color 0.3s;

      &:hover {
        border-color: #409EFF;
      }

      .banner-uploader-icon {
        font-size: 24px;
        color: #8c939d;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .banner {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
    }

    .banner-delete-btn {
      position: absolute;
      top: -10px;
      right: -10px;
      padding: 6px;
      font-size: 12px;
    }
  }

  .banner-add-btn {
    display: flex;
    align-items: center;

    .el-button {
      width: 200px;
      height: 100px;
    }
  }
}

.banner-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

/* 营业时间样式 */
.work-time-global {
  .time-set-default {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f8f8f8;
    border-radius: 4px;

    .el-time-picker {
      width: 120px;
    }

    .apply-all-btn {
      margin-left: auto;
    }
  }

  .custom-collapse {
    border: none;

    .custom-collapse-title {
      font-size: 14px;
      color: #409EFF;
    }

    :deep(.el-collapse-item__header) {
      border: none;
      height: auto;
      padding: 0;
      margin-bottom: 10px;
    }

    :deep(.el-collapse-item__wrap) {
      border: none;
      background: transparent;
    }

    .work-time-item {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;
      margin-bottom: 15px;

      .day-label {
        width: 50px;
        font-size: 14px;
        color: #606266;
      }

      .el-time-picker {
        width: 120px;
      }
    }
  }
}

/* 表单元素样式 */
.custom-input {
  width: 300px;
}

.custom-textarea {
  width: 100%;
  max-width: 500px;
}

.time-separator {
  margin: 0 10px;
  color: #606266;
}

.submit-btn {
  width: 120px;
}
</style>